import ApiResourceManager from '../ApiResourceManager';

export default class GoogleAdsManager extends ApiResourceManager {
  connectCampaign = (data) =>
    this.request({
      method: 'POST',
      url: '/google-ads/connect-campaign',
      data,
    });

  getCampaigns = (params) =>
    this.request({
      method: 'GET',
      url: '/google-ads/campaigns',
      params,
    });

  getCampaign = (id) =>
    this.request({
      method: 'GET',
      url: `/google-ads/campaigns/${id}`,
    });

  getCompanyStats = (params) =>
    this.request({
      method: 'GET',
      url: '/google-ads/company-stats',
      params,
    });
}
